import { AddIcon } from "components/common/Icons/AddIcon";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { SortIcon } from "components/common/Icons/SortIcon";
import { ResizeSettingsOption } from "../ResizeSettingsOption/ResizeSettingsOption";
import { ActiveType } from "../useBottomMenu";
import { stopPropagation } from "client/utils/stopPropagation";

export interface OptionsProps {
    openPopup: (activeType: ActiveType | null) => void;
}

export const Options = ({ openPopup }: OptionsProps) => {
    return (
        <div className="bg-irBlue-200 dark:bg-darkPrimary-100 rounded-xl flex items-center w-full">
            <div
                className="flex items-center justify-center py-4 px-4 border-r border-r-irBlue-400"
                onClick={stopPropagation(() => openPopup("add"))}
            >
                <AddIcon className="fill-white" />
            </div>
            <div
                className="flex items-center justify-center py-4 px-4 border-r border-r-irBlue-400"
                onClick={stopPropagation(() => openPopup("delete"))}
            >
                <DeleteIcon className="fill-white" />
            </div>

            <ResizeSettingsOption onOpen={() => openPopup(null)} />

            <div className="px-4" onClick={stopPropagation(() => openPopup("sort"))}>
                <SortIcon className="fill-white" />
            </div>
        </div>
    );
};
